import React from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCityTimezone } from '@/modules/partner/store/selectors';
import { TwoLineCell } from '@/shared/view/TwoLineCell';

interface ILastActiveCellProps {
  lastActivity?: Date;
}

const LastActiveCell = React.memo<ILastActiveCellProps>(({ lastActivity }) => {
  const timeZone = useSelector(getCityTimezone) ?? 'utc';

  return lastActivity ? (
    <TwoLineCell
      line1={<FormattedDate value={lastActivity} timeZone={timeZone} />}
      line2={<FormattedTime value={lastActivity} timeZone={timeZone} />}
    />
  ) : (
    <FormattedMessage defaultMessage="No" id="/adrJa" description="No last activity for driver" />
  );
});

export { LastActiveCell };
